import l, { createContext as t, useContext as p } from "react";
var n = t(null);
n.displayName = "OpenClosedContext";

var d = function (e) {
  return e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e;
}(d || {});

function C() {
  return p(n);
}

function c(_ref) {
  var o = _ref.value,
      r = _ref.children;
  return l.createElement(n.Provider, {
    value: o
  }, r);
}

export { c as OpenClosedProvider, d as State, C as useOpenClosed };